var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOfficeBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:office-building-marker-outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 13.0909H4.38889V11.6364H5.83333V13.0909Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38889 8.72727H5.83333V10.1818H4.38889V8.72727Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38889 5.81818H5.83333V7.27273H4.38889V5.81818Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 2.90909H4.38889V4.36364H5.83333V2.90909Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27778 10.1818H8.72222V8.72727H7.27778V10.1818Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72222 2.90909H7.27778V4.36364H8.72222V2.90909Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27778 7.27273H8.72222V5.81818H7.27778V7.27273Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6111 2.90909H10.1667V4.36364H11.6111V2.90909Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6111 5.81818H10.1667V7.27273H11.6111V5.81818Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 13.0909H11.6111V11.6364H10.1667V13.0909Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6111 8.72727H10.1667V10.1818H11.6111V8.72727Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0H14.5L14.5 16H1.5V0ZM2.94444 14.5455H7.27778V12H8.72222V14.5455H13.0556V1.45455H2.94444V14.5455Z",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOfficeBuilding);
export default __webpack_public_path__ + "static/media/icon--office-building.6f30e9a80ad55b8fbd27f84071596ba5.svg";
export { ForwardRef as ReactComponent };